import gql from "graphql-tag";

export const GetUsers = () => {
  return gql`
    query getUsers {
      users {
        given_name
        family_name
        email
        sub
      }
    }
  `;
};

export const GetEnabledModules = tenantID => {
  return gql`query GetEnabledModules {
      getEnabledModules(tenantID:"${tenantID}"){
        modules
        sub_modules {
          categories
          sub_module_name
        }
      }
    }`;
};

export const GetEnabledSubModules = () => {
  return gql`query GetSubModules ($module: String!) {
    getSubModules(input: $module) {
      isActive
      name
      displayName
    }
  }`;
}

export const GetTenant = tenantID => {
  return gql`query GetTenant {
      tenant(tenantID:"${tenantID}"){
        tenantID
        companyName
        logo
      }
    }`;
};

export const CreateCompanyProfile = () => {
  return gql`mutation CreateCompanyProfile($tenantId: String!,$address:String,
    $currentStep:Int!, $revenue:Float, $industry:String, $numEmployees:String,
    $yearsInBusiness:Int, $companyDescription:String, $employeeLocation:String,
    $productDeliveryOptions:String, $dataCollected:[String], $numRecordsProcessed: String,
    $dataLocation: String, $thirdPartyAccess:String ){
    createCompanyProfile(input: {address: $address, tenantId: $tenantId,currentStep: $currentStep,
    revenue: $revenue, industry: $industry, numEmployees: $numEmployees, yearsInBusiness: $yearsInBusiness,
    companyDescription: $companyDescription, employeeLocation:$employeeLocation,
    productDeliveryOptions:$productDeliveryOptions, dataCollected: $dataCollected,
    numRecordsProcessed:$numRecordsProcessed, dataLocation:$dataLocation, thirdPartyAccess:$thirdPartyAccess}) {
      timeCompleted
      address
      revenue
      yearsInBusiness
      numEmployees
      oneliner
      productDeliveryOptions
      employeeLocation
      numRecordsProcessed
      dataLocation
      thirdPartyAccess
      industry
      companyDescription
      employeeLocation
      dataCollected
    }
  }`;
}

export const UpdateCompanyProfile = () => {
  return gql`mutation UpdateCompanyProfile($tenantId: String!, $address:String, $currentStep:Int ){
    updateCompanyProfile(input: {address: $address, tenantId: $tenantId, currentStep: $currentStep}) {
      timeCompleted
      address
      revenue
      yearsInBusiness
      numEmployees
      oneliner
      productDeliveryOptions
      employeeLocation
      numRecordsProcessed
      dataLocation
      thirdPartyAccess
      industry
    }
  }`;
}

export const GetCompanyProfile = (tenantID) => {
  return gql`query GetCompanyProfile{
    getCompanyProfile(tenantId: "${tenantID}") {
      address
      companyDescription
      currentStep
      dataCollected
      dataLocation
      employeeLocation
      industry
      numEmployees
      numRecordsProcessed
      oneliner
      productDeliveryOptions
      revenue
      tenantId
      thirdPartyAccess
      timeCompleted
      yearsInBusiness
    }
  }`;
}


// WEBPACK FOOTER //
// ./src/queries/users.js